import { Site } from "./site";

export class SitePicture {
    id?: string;
    site?: Site;
    siteId?: string;
    picture?: string;
}
